import React, { useEffect, useState } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { toast } from 'react-toastify';
import AuthLayout from '../../../components/auth/AuthLayout';

const SignupPan = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { mobile } = location.state || {};
  const [panNumber, setPanNumber] = useState('');
  const [loading, setLoading] = useState(false);
  const [panDetails, setPanDetails] = useState(null);

  useEffect(() => {
    if (!mobile) {
      navigate('/signup', { replace: true });
    }
  }, [mobile, navigate]);

  const handleSubmit = async (event) => {
    event.preventDefault();

    if (!/^[A-Z]{5}[0-9]{4}[A-Z]$/.test(panNumber)) {
      toast.error('Please enter a valid PAN number');
      return;
    }

    setLoading(true);

    try {
      // TODO: Replace with actual API call
      // const response = await authServices.verifyPan(panNumber.toUpperCase());

      // Simulating API call
      await new Promise(resolve => setTimeout(resolve, 1000));

      const details = {
        namePanCard: 'Demo User',
        panNumber: panNumber.toUpperCase(),
        status: 'VALID',
      };

      setPanDetails(details);
      toast.success('PAN verified successfully');

      navigate('/signup/aadhaar', {
        state: { mobile, panDetails: details }
      });
    } catch (error) {
      toast.error('Failed to verify PAN. Please try again.');
    } finally {
      setLoading(false);
    }
  };

  const handleBack = () => {
    navigate('/signup/otp', { state: { mobile } });
  };

  return (
    <AuthLayout
      title="Verify PAN"
      subtitle="Verify your PAN to continue or skip to upload"
      onBack={handleBack}
    >
      <form onSubmit={handleSubmit}>
        <div className="form-group">
          <label className="form-label">PAN Number</label>
          <input
            type="text"
            className="form-input"
            value={panNumber}
            onChange={(event) => setPanNumber(event.target.value.toUpperCase())}
            placeholder="ABCDE1234F"
            maxLength={10}
            required
          />
        </div>
        <button type="submit" className="signin-btn" disabled={loading}>
          {loading ? 'Verifying...' : 'Verify PAN'}
        </button>
      </form>
      <div className="signup-section" style={{ marginTop: '1.5rem' }}>
        <p className="signup-text">
          Prefer manual upload?{' '}
          <button
            type="button"
            className="signup-link"
            onClick={() => navigate('/signup/pan-upload', { state: { mobile } })}
          >
            Skip and upload PAN
          </button>
        </p>
      </div>
      {panDetails?.namePanCard && (
        <div
          style={{
            marginTop: '1.5rem',
            padding: '1rem',
            borderRadius: '12px',
            background: '#f8fafc',
            border: '1px solid #e2e8f0',
          }}
        >
          <h4 style={{ marginBottom: '0.75rem' }}>PAN Preview</h4>
          <p><strong>Name:</strong> {panDetails.namePanCard}</p>
          <p><strong>PAN:</strong> {panDetails.panNumber}</p>
        </div>
      )}
    </AuthLayout>
  );
};

export default SignupPan;


